import { ref, Ref } from 'vue';

import { v4 as uuidv4 } from 'uuid';


class Notification {
  id: string;
  message: string;
  showUntil: Date;

  constructor(message: string, duration: number) {
    this.id = uuidv4();
    this.message = message;

    const showUntil = new Date();
    showUntil.setSeconds(showUntil.getSeconds() + duration);
    this.showUntil = showUntil;
  }
}

class NotificationManager {
  notifications: Ref<Array<Notification>> = ref([]);

  add(message: string, duration = 5) {
    this.notifications.value = [...this.notifications.value, new Notification(message, duration)];
  }
}

const notifications = new NotificationManager();
window.notifications = notifications;

export { notifications }
